var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90.794,
    height: 116.045,
    viewBox: "0 0 90.794 116.045",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "left_hand",
    transform: "translate(-157.984 -429.66)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2634",
    "data-name": "Group 2634",
    transform: "translate(160 431.666)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1861",
    "data-name": "Path 1861",
    d: "M10765.443,1423.448c5.326-5.326,10.834-6.881,15.02-10.852,11.15-6.347,18.3,7.786,9.447,14.916-14.437,8.36-19.248,23.4-33.342,31.441-15.187,11.309-59.238-6.982-47.471-52.7.436-3.068.051-12.926,3.088-14.763,11.85-7.17,11.789,6.032,11.566,6.712-1.4-15.427,15.889-14.777,15.063.389-.322,5.965,0-12.427,7.1-12.427,8.877,0,6.582,8.724,7.1,15.977,2.162-3.923,5.846-26.95,12.426-40.831,2.916-6.149,5.488-12.968,12.428-10.653,5.328,1.777,2.713,11.928,1.775,15.979C10774.492,1385.469,10770.334,1404.877,10765.443,1423.448Z",
    transform: "translate(-10707.124 -1350.198)",
    fill: "#f3a65a",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("text", {
    id: "L",
    transform: "translate(186 518)",
    fill: "#fff",
    fontSize: 30,
    fontFamily: "Quicksand-Bold, Quicksand",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "L")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftHand);
export default __webpack_public_path__ + "static/media/left_hand.59394c43f266fa3ad82ebc06b7d1f949.svg";
export { ForwardRef as ReactComponent };